<div id="sidebar-user" class="offcanvas offcanvas-end">
  <div class="offcanvas-body overflow-hidden p-0 corners">
    <div class="offcanvas-header p-0 ps-2">
      <div class="flex-grow-1">
        <h4 class="mb-0" i18n="@@SidebarUserTitle">User</h4>
      </div>
      <button type="button" data-bs-dismiss="offcanvas" aria-label="Close" class="btn p-2">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <hr class="m-0" />

    @if (!loggedIn) {
      <ul class="list-group list-group-flush">
        <a class="list-group-item" [routerLink]="['login']" i18n="@@SidebarUserLogin" data-bs-dismiss="offcanvas">Login</a>
      </ul>
    }

    @if (loggedIn) {
      <ul class="list-group list-group-flush">
        <a class="user list-group-item" [routerLink]="['user']" data-bs-dismiss="offcanvas">
          <span i18n="@@SidebarUserPersonallyStatements">Personal statements</span>
        </a>
        @if (isOrderCheckoutAllowed == true) {
          <a [routerLink]="['user', 'order-list']" class="user list-group-item" data-bs-dismiss="offcanvas">
            <span i18n="@@SidebarUserOrderList">Order list</span>
          </a>
        }
        @if (isUserAdmin == true) {
          <a class="user list-group-item" [routerLink]="['/user', 'management-list']" data-bs-dismiss="offcanvas">
            <i class="bi bi-person me-2"></i>
            <span i18n="@@SidebarUserUserManagement">User management</span>
          </a>
        }
        @if (isMultiCustomerUser == true) {
          <a class="user list-group-item c-pointer" (click)="switchUserDialogShow()" data-bs-dismiss="offcanvas">
            <i class="bi bi-person me-2"></i>
            <span i18n="@@SidebarUserSwitchCustomer">Change your establishment</span>
          </a>
        }
        <a class="user list-group-item" [routerLink]="anonymousLandingPage.routerlink" [queryParams]="anonymousLandingPage.queryParams" (click)="logout()" data-bs-dismiss="offcanvas">
          <i class="bi bi-box-arrow-right me-2"></i>
          <span i18n="@@SidebarUserLogout">Logout</span>
        </a>
      </ul>
    }
  </div>
</div>
